import React, { useEffect, useState } from "react";
import { Layout, Card, Button, Steps, Typography } from "antd";



import {
  SaveOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";

import StoryDetailsSection from "../../components/story-editor/StoryDetailsSection";
import CharacterSection from "../../components/story-editor/CharacterSection";
import BackgroundSection from "../../components/story-editor/BackgroundSection";
import SentenceSection from "../../components/story-editor/SentenceSection";
import ImageSection from "../../components/story-editor/ImageSection";
import AudioSection from "../../components/story-editor/AudioSection";
import ActorSection from "../../components/story-editor/ActorSection";

import useStoryEditor from "../../hooks/useStoryEditor";





const { Content } = Layout;

const StoryEditorInner = ({ navigate }) => {
  const { Title, Text } = Typography;
  const location = useLocation();

  const editor = useStoryEditor(navigate);

  const {
    setStoryId,
    setMode,
    selectedCharacters,
    publishClicked,
    publishStory,
    handleSaveSentencesClick,
    mode,
  } = editor;

  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    if (location.state?.storyId) {
      setStoryId(location.state.storyId);
    }

    if (location.state?.mode) {
      setMode(location.state.mode);
    }
  }, [location.state]);

  const steps = [
    {
      title: "Geschichtenübersicht",
      component: <StoryDetailsSection {...editor} />,
    },
    {
      title: "Actors",
      component: <ActorSection {...editor} />,
    },
    {
      title: "Charaktere",
      component: <CharacterSection {...editor} />,
    },
    {
      title: "Hintergründe",
      component: <BackgroundSection {...editor} />,
    },
    {
      title: "Bildressourcen",
      component: <ImageSection {...editor} />,
    },
    {
      title: "Audioressourcen",
      component: <AudioSection {...editor} />,
    },
    {
      title: "Sätze",
      component: (
        <SentenceSection
          {...editor}
          onSave={handleSaveSentencesClick}
        />
      ),
    },
  ];

  const canShowSentenceStep =
    (publishClicked ||
      mode === "edit") &&
    selectedCharacters.length > 0;

  const visibleSteps = canShowSentenceStep
    ? steps
    : steps.slice(0, 5);

  return (

    <Content className="content">
      <Title level={3}>
        Geschichten-Editor
      </Title>
      <Card className="mainEditorContainer" bordered>


        {/* STEP HEADER */}

        <div style={{ marginBottom: 30 }}>

          <Steps
            current={currentStep}
            onChange={(step) => setCurrentStep(step)}
            items={visibleSteps.map((s) => ({
              title: s.title,
            }))}
          />

          <div
            style={{
              textAlign: "center",
              marginTop: 20,
            }}
          >
            <h2>
              Schritt {currentStep + 1} von{" "}
              {visibleSteps.length}
            </h2>
          </div>

        </div>

        {/* CURRENT STEP CONTENT */}

        {visibleSteps[currentStep]?.component}

        {/* FOOTER NAVIGATION */}

        <div
          style={{
            marginTop: 40,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 16,
          }}
        >

          <Button
            className="story-editor-btn-default"
            icon={<LeftOutlined />}
            disabled={currentStep === 0}
            onClick={() =>
              setCurrentStep((prev) => prev - 1)
            }
          >
            Zurück
          </Button>

          <Button
            icon={<SaveOutlined />}
            type="primary"
            onClick={() => publishStory(mode)}
          >
            {mode === "edit"
              ? "Geschichte aktualisieren"
              : "Geschichte speichern"}
          </Button>

          <Button
            className="story-editor-btn-default"
            icon={<RightOutlined />}
            disabled={
              currentStep === visibleSteps.length - 1
            }
            onClick={() =>
              setCurrentStep((prev) => prev + 1)
            }
          >
            Weiter
          </Button>

        </div>

      </Card>

    </Content>

  );
};

export default StoryEditorInner;